export default function setup() {
	$(document).ready(function () {
		$.ajaxSetup({ cache: false });
		$(".modal-window").click(function (e) {
			e.preventDefault();
			$.get(this.href, function (data) {
				$('#dialogContent').html(data);
				$('#modalWindowDialog').modal('show');
			});
		});
	})

	$(document).ready(function () {
		$.ajaxSetup({ cache: false });
		$(".modal-window-second").click(function (e) {
			e.preventDefault();
			$.get(this.href, function (data) {
				$('#dialogContentSecond').html(data);
				$('#modalWindowDialogSecond').modal('show');
			});
		});
	})
}